import Cookies from 'universal-cookie'

const cookies = new Cookies()

const AUTH_FORM_ACTIONS = new Set([
    'employeeLogin',
    'employeeUpdatePassword',
    'userAuthVerifyCode',
    'userForgetPassword',
    'userForgetPasswordPostPassword',
    'userForgetPasswordVerifyCode',
    'userLogin',
    'userPostInfo',
    'userSendCode',
    'userSignup',
])

let redirectStarted = false

const normalizeMessage = value => {
    return typeof value === 'string'
        ? value.replace(/\{\{lang\}\}/g, '').trim().toLowerCase()
        : ''
}

const getResponseMessages = response => {
    if (!response || typeof response !== 'object') return []

    return [
        response.message,
        response.error,
        response.code,
        response?.message?.code,
        response?.error?.message,
    ].map(normalizeMessage).filter(Boolean)
}

export const isUnauthorizedResponse = ({
    action,
    response,
    status,
}) => {
    if (AUTH_FORM_ACTIONS.has(action)) return false

    const messages = getResponseMessages(response)
    const hasSessionFailure = messages.some(message => {
        return message.includes('errors.securitycheckfailed')
            || message.includes('errors.tokennotverified')
            || message.includes('authentication required')
            || message.includes('authenticated workflow actor is required')
            || message.includes('authenticated record actor is required')
            || message.includes('authenticated chart actor is required')
            || (status === 401 && message.includes('unauthorized'))
    })

    if (hasSessionFailure) return true
    return status === 401
}

export const logoutAndRedirectToLogin = ({
    cookieStore = cookies,
    location = typeof window !== 'undefined' ? window.location : null,
} = {}) => {
    cookieStore.remove('admintoken', { path: '/' })

    if (!location || location.pathname === '/login' || redirectStarted) {
        return false
    }

    redirectStarted = true
    location.replace('/login')
    return true
}

export const resetUnauthorizedRedirectForTests = () => {
    redirectStarted = false
}
